function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

export { _isNativeFunction as default };
//# sourceMappingURL=isNativeFunction.js.map
